import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';

// Utility function to filter out GoogleMapReact internal props
const filterProps = (props) => {
  const { $geoService, $hover, $dimensionKey, ...rest } = props;
  return rest; // Return only the relevant props for rendering
};

const JobPickupLocation = ({ text, data }) => (
  <div style={{
      position: 'relative', color: 'white', background: 'green', textAlign: 'center',
      height: 15, width: 15, borderRadius: '0', content: "P", lineHeight: "15px"
    }}
    className="P"
    >
    P
  </div>
);
const JobDropoffLocation = ({ text, data }) => (
  <div style={{
      position: 'relative', color: 'white', background: 'red', textAlign: 'center',
      height: 15, width: 15, borderRadius: '0', content: "D", lineHeight: "15px"
    }}
    className="D"
    >
    D
  </div>
);
const GeoLocation = (props) => {
  const { data, lat, lng, isSelected, onClick } = props;
  const filteredProps = filterProps(props);

  return (
    <div onClick={onClick} style={{ position: 'relative' }}>
      {/* Marker */}
      <div style={{
        position: 'relative',
        color: 'white',
        background: 'blue',
        textAlign: 'center',
        height: 7,
        width: 7,
        borderRadius: 0,
        lineHeight: 0
      }} {...filteredProps} />

      {/* Show popup if this marker is selected */}
      {isSelected && (
        <div
          className="location-details-popup"
          style={{
            position: 'absolute',
            top: '-120%',  // Adjusts popup position relative to marker
            left: '20px',
            backgroundColor: 'white',
            padding: '10px',
            borderRadius: '5px',
            boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
            width: '200px',
          }}
        >
          <button
            onClick={(e) => {
              e.stopPropagation(); // Prevents click event from triggering marker click
              props.onClose();
            }}
            style={{
              position: 'absolute',
              top: '5px',
              right: '5px',
              border: 'none',
              background: 'transparent',
              fontSize: '16px',
              cursor: 'pointer',
            }}
          >
            X
          </button>
          <h4 style={{ margin: '0 0 5px 0', fontWeight: 'bold' }}>Location Details</h4>
          <p style={{ margin: '0' }}><strong>ID:</strong> {data.id}</p>
          <p style={{ margin: '0' }}><strong>Latitude:</strong> {lat}</p>
          <p style={{ margin: '0' }}><strong>Longitude:</strong> {lng}</p>
          <p style={{ margin: '0' }}><strong>At Date time:</strong> {data.geolocated_at}</p>
        </div>
      )}
    </div>
  );
};


export default class SingleJobMapWithGeolocations extends Component {
  static googleMap;
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      jobId: props.jobId,
      visible: false,
      center: {lat: 53.0236, lng: -2.211},
      zoom: 7,
      geoLocations: [],
      selectedLocationId: null,  // Store the ID of the selected location
      pickupAddress: props.pickupAddress || [],
      dropoffAddress: props.dropoffAddress || [],
      url: props.url || "/api/v1/portal/geolocations/job/"+props.data.jobId,
      bootstrapURLKeys: { key: process.env.MIX_GOOGLE_API_KEY },
      showMap: false
    };
  }
  getGeolocations() {
    // Fetch geolocations data
    let url = this.state.url;
    fetch(url, {
      method: "GET",
      headers: {
        Authorization: 'Bearer ' + window.api_token,
        Accept: 'application/json',
      },
    })
      .then(response => response.json())
      .then(geoLocationsJson => this.setState({ geoLocations: geoLocationsJson }))
      .catch(error => console.error('Error fetching geolocations:', error));
  }

  handleMarkerClick = (id) => {
    this.setState({ selectedLocationId: id });
  };

  handleClosePopup = () => {
    this.setState({ selectedLocationId: null });
  };

  handleShowMap = () => {
    this.setState({ showMap: true }, () => {
      this.getGeolocations();
    });
  };

  render() {
    const { geoLocations, selectedLocationId, showMap } = this.state;
    return (
      <div id="g4-logistics-portal-jobs-table-job-full-details-map-container">
        {showMap ? (
          <GoogleMapReact
            bootstrapURLKeys={this.state.bootstrapURLKeys}
            defaultCenter={this.state.center}
            defaultZoom={this.state.zoom}
            resetBoundsOnResize
          >
            {geoLocations.map((location) => (
              <GeoLocation
                key={`geolocation-${location.id}`}
                data={location}
                lat={location.latt}
                lng={location.long}
                isSelected={selectedLocationId === location.id}
                onClick={() => this.handleMarkerClick(location.id)}
                onClose={this.handleClosePopup}
              />
            ))}
            <JobDropoffLocation
              data={this.props.data.dropoffAddress}
              key={"dropoff-" + this.props.data.dropoffAddress.id}
              lat={this.props.data.dropoffAddress.latt}
              lng={this.props.data.dropoffAddress.long}
            />
            <JobPickupLocation
              data={this.props.data.pickupAddress}
              key={"pickup-" + this.props.data.pickupAddress.id}
              lat={this.props.data.pickupAddress.latt}
              lng={this.props.data.pickupAddress.long}
            />
          </GoogleMapReact>
        ) : (
          <>
            <img
              src="/images/job/logistics-portal.png"
              alt="map placeholder"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                opacity: 0.4,
                top: 0,
                left: 0
              }}
            />
            <button
              onClick={this.handleShowMap}
              id="load-map"
              className='btn btn-lg btn-primary'
            >
              Click here for the latest mapping details
            </button>
          </>
        )}
      </div>
    );
  }
}